<header class="company-analysis-header" data-cy="company-analysis-header">
  <div class="company-analysis-header__identity">
    <span class="company-analysis-header__avatar" aria-hidden="true">{{ initials }}</span>

    <div class="company-analysis-header__text">
      <h1 class="company-analysis-header__name">{{ company?.corporateName }}</h1>

      <p class="company-analysis-header__meta">
        <span *ngIf="company?.cnpj">CNPJ {{ company?.cnpj | vaultMaskCnpj }}</span>
        <span class="company-analysis-header__separator" *ngIf="company?.cnpj && location">·</span>
        <span *ngIf="location">{{ location }}</span>
      </p>
    </div>
  </div>

  <div class="company-analysis-header__actions">
    <app-button
      [label]="toggleAllLabel"
      [type]="'button'"
      [theme]="'white'"
      data-cy="toggle-all-stages-btn"
      (sendButtonClick)="toggleAll.emit()">
    </app-button>
  </div>
</header>
